import ApiRequestManagerInstance from '../ApiRequestManager';
import EpgEvent from '../../classes/epgEvent';
import { EventMap, IIncomingEventsRequest } from '../../types/interfaces/event';
import { store } from '@shared/store/store';
import { setLastModifiedDate } from '@shared/store/slices/events.slice';

export default function incomingEventsRequest() {
  const promise = new Promise<EventMap>(async (resolve, reject) => {
    try {
      const response: IIncomingEventsRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'cdnSyncUrl',
            section: 'media',
            subsection: 'carrier',
            type: 'incomingEvents',
          },
        })) as unknown as IIncomingEventsRequest;

      // Filter, sort and save events into object

      const {
        channels: { channelsData },
      } = store.getState();

      const events: EventMap = {};
      Object.keys(response.data).forEach((key) => {
        if (channelsData?.find((channel) => channel.id === key)) {
          events[key] = [];
          response.data[key].forEach((value) => {
            const event = new EpgEvent(value);
            events[key].push(event);
          });
        }
      });

      const {events:eventsSlice} = store.getState()
      const {lastModifiedDate} = eventsSlice

      const responseHeaders = response.headers as {"last-modified": string}
      if(responseHeaders["last-modified"] && responseHeaders["last-modified"].length) {
        var lastModifiedDateMS = new Date(responseHeaders["last-modified"]).getTime()
        if(lastModifiedDateMS) {
          if(lastModifiedDate === lastModifiedDateMS) {
            store.dispatch(setLastModifiedDate(Date.now())) // If backend is too slow request again with curren date (It will run the request ~ 30 min after current date)
          }else {
            store.dispatch(setLastModifiedDate(lastModifiedDateMS))
          }
        }
      }

      // Object.keys(events).forEach((key) => {
      //   events[key] = events[key].sort((item1, item2) => {
      //     if ((item1?.date?.start || 0) > (item2?.date?.start || 0)) {
      //       return 1;
      //     }
      //     return -1;
      //   });
      // });

      resolve(events);
    } catch (e) {
      store.dispatch(setLastModifiedDate(Date.now()))
      reject([]);
    }
  });

  return promise;
}
